import { useDonation } from '../../context/DonationContext';
import { useNavigate } from 'react-router-dom';

export default function Confirmation() {
    const { donation } = useDonation();
    const navigate = useNavigate();

    const handleConfirm = () => {
        navigate('/gracias');
    };

    return (
        <div className="max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-6">Confirma tu donación</h2>

            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h3 className="font-bold mb-2">Resumen:</h3>
                <p>Monto: ${donation.amount} MXN</p>
                <p>Frecuencia: {donation.frequency === 'one_time' ? 'Única' : 'Recurrente'}</p>
            </div>

            <button
                onClick={handleConfirm}
                className="bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700"
            >
                Confirmar donación
            </button>
        </div>
    );
}